import React from "react";
import "./OffersOn.css";

function OffersOn(props) {
  const { polygon35, offers } = props;

  return (
    <div className="offers-on">
      <div className="overlap-group-12">
        <div className="rectangle-131"></div>
        <img className="polygon-35" src={polygon35} />
        <div className="offers-5 poppins-medium-white-10px">{offers}</div>
      </div>
    </div>
  );
}

export default OffersOn;
